export default __webpack_public_path__ + "static/media/ic_close_white.d3ea21e7.svg";